import { Box, Dialog, DialogContent } from '@mui/material'
import React from 'react'
import { DeleteOutlineOutlined } from '@mui/icons-material'

function DeleteModel({ open, onClose, onConfirm, title = "Delete Screen", message = "Are you sure you want to delete this screen? This action cannot be undone." }) {
  return (
    <Dialog
      open={open}
      onClose={() => onClose(false)}
      maxWidth="xs"
      fullWidth
      sx={{ zIndex: '100000000' }}
      PaperProps={{
        sx: {
          borderRadius: '16px',
          overflow: 'hidden',
          fontFamily: "'Inter', sans-serif",
        },
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            pt: 4,
            pb: 3.5,
            px: 4,
          }}
        >
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              backgroundColor: '#FEE2E2',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              mb: 2.5,
            }}
          >
            <DeleteOutlineOutlined sx={{ fontSize: 32, color: '#EF4444' }} />
          </Box>

          <Box
            sx={{
              fontFamily: "'Inter', sans-serif",
              fontWeight: 600,
              fontSize: '18px',
              color: '#111827',
              mb: 1,
            }}
          >
            {title}
          </Box>

          <Box
            sx={{
              fontFamily: "'Inter', sans-serif",
              fontSize: '14px',
              color: '#6B7280',
              textAlign: 'center',
              lineHeight: 1.6,
              mb: 3.5,
              maxWidth: '280px',
            }}
          >
            {message}
          </Box>

          <Box
            sx={{
              display: 'flex',
              gap: '12px',
              width: '100%',
            }}
          >
            <button
              onClick={() => onClose(false)}
              style={{
                flex: 1,
                height: '40px',
                background: 'white',
                color: '#374151',
                border: '1px solid #D1D5DB',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: 500,
                fontFamily: "'Inter', sans-serif",
                cursor: 'pointer',
                transition: 'all 0.15s ease',
              }}
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              style={{
                flex: 1,
                height: '40px',
                background: '#EF4444',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: 500,
                fontFamily: "'Inter', sans-serif",
                cursor: 'pointer',
                transition: 'all 0.15s ease',
              }}
            >
              Delete
            </button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default DeleteModel
